import React from "react";
import styled, { css } from "styled-components";

const SIZE_STYLES = {
  sm: css`
    padding: 12px 14px;
    font-size: 14px;
  `,
  md: css`
    padding: 16px 18px;
    font-size: 15px;
  `,
  lg: css`
    padding: 20px 22px;
    font-size: 17px;
  `,
};

const IconInputField = ({
  label,
  icon,
  size = "md",
  borderRadius,
  inputRef,
  ...props
}) => {
  return (
    <FieldGroup>
      {label && <FieldLabel>{label}</FieldLabel>}
      <InputWrapper $size={size} $borderRadius={borderRadius}>
        {icon && <IconWrapper>{icon}</IconWrapper>}
        <Input ref={inputRef} $size={size} {...props} />
      </InputWrapper>
    </FieldGroup>
  );
};

export default IconInputField;

const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FieldLabel = styled.span`
  color: ${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
`;

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: ${({ $borderRadius }) => $borderRadius || "4px"};
  background: ${({ theme }) => theme.menu.groupContentBackground};
  color: ${({ theme }) => theme.menu.secondaryTextColor};

  ${({ $size }) => SIZE_STYLES[$size] || SIZE_STYLES.md}

  &:focus-within {
    outline: 2px solid ${({ theme }) => theme.primaryButton.borderColor};
    outline-offset: 2px;
  }
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const Input = styled.input`
  background: none;
  border: none;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-weight: 500;
  line-height: 1.3;
  width: 100%;
  padding: 0;
  font-size: inherit;

  &:focus-visible {
    outline: none;
  }
`;
